const isDowngrading = ({ userCurrentPlan, selectedPlan }) => {
  if (
    typeof userCurrentPlan?.order === "undefined" ||
    typeof selectedPlan?.order === "undefined"
  ) {
    return false;
  }

  return selectedPlan.order < userCurrentPlan.order;
};

export default isDowngrading;
